var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRdStation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2596 20.3642L18.6795 22.6877L21.9602 21.14L12.2597 17.6268L2.56697 21.1399L5.84776 22.9041Z",
    fill: "#19C1CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2596 8.3941L2.04688 4.69238V8.0114L12.2596 11.7131L22.4804 8.0114V4.69238L12.2596 8.3941Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2677 17.4145L22.4805 21.1162L22.4805 17.7972L12.2677 14.0955L2.04694 17.7972L2.04694 21.1162L12.2677 17.4145Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2596 5.23154L5.83768 2.9043L2.04688 4.69265L12.2596 8.39436L22.4804 4.69265L18.6896 2.9043L12.2596 5.23154ZM18.6795 3.12066L12.2596 5.44425L5.84776 3.12068L2.56697 4.66843L12.2597 8.18164L21.9602 4.66836L18.6795 3.12066Z",
    fill: "#19C1CE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdStation);
export default __webpack_public_path__ + "static/media/rd_station.9ef057ca.svg";
export { ForwardRef as ReactComponent };